export { default } from "./ButtonTabs";
